<template>
  <div class="report__block-footer">
    <div
      v-if="!getPurchasedInfo[type] && !getIsLegacy"
      class="block-footer__buy-wrapper"
    >
      <BuyButton
        size="large"
        :type="type"
      />
      <div
        v-if="type == 'tier2'"
        class="block-footer__buy-text"
      >
        Money Trail + Risk Score
      </div>
      <div
        v-if="type == 'full'"
        class="block-footer__buy-text"
      >
        Full Report
      </div>
    </div>
  </div>
</template>

<script>
// components
import BuyButton from '@/pages/report/components/section-components/BuyButton'
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'ReportBlockFooter',
  components: {
    BuyButton,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    purchasedPartInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('report', ['getPurchasedInfo', 'getIsLegacy']),
  },
}
</script>

<style scoped>
.report__block-footer {
  width: 100%;
  padding-top: 8px;
}
.block-footer__buy-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.block-footer__buy-text {
  width: 100%;
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  text-align: center;
  font-size: var(--Size-S, 12px);
  font-weight: 500;
  line-height: var(--Line-Height-S, 16px);
}
</style>
